import { Typography } from '@mui/material'

export default function BeheardReportTitle({ children }: any) {
  return (
    <Typography variant='h6' color='text.primary' paragraph>
      {children}
    </Typography>
  )
}
